import React from "react";
import "./App.css";
import { LanguageProvider } from "./i18n/LanguageContext";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Welcome from "./components/Welcome";
import HowItWorks from "./components/HowItWorks";
import Cards from "./components/Cards";
import Coverage from "./components/Coverage";
import News from "./components/News";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-background text-foreground antialiased">
        <Navbar />
        <main>
          <Hero />
          <Welcome />
          <HowItWorks />
          <Cards />
          <Coverage />
          <News />
          <Contact />
        </main>
        <Footer />
        <CookieBanner />
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
